import { css } from 'styled-components'
import { convertColor } from '../../libs'
import { color, ColorsSchemeCoreNames } from '../colors'

export const opacityBackgroundCss = css<{ bgImage?: string; bgColor?: string }>`
	background: ${({ bgImage, bgColor: bc, theme }) => {
		const bgColor = bc || 'ghost'
		if (!bgImage) {
			if (bgColor && bgColor !== 'none')
				return color(bgColor as ColorsSchemeCoreNames)
			else return 'transparent'
		}
		return bgColor === 'none'
			? bgImage
				? getImageCss(bgImage)
				: ''
			: bgColor?.match(/gradient/g)
			? theme?.gradients?.[bgColor.replace('gradient-', '')] +
			  `0 0 / cover, ${bgImage ? getImageCss(bgImage) : ''}`
			: `linear-gradient(${color(bgColor as ColorsSchemeCoreNames)({
					theme,
			  })}CC, ${color(bgColor as ColorsSchemeCoreNames)({
					theme,
			  })}CC) 0 0 / cover ${bgImage ? ', ' + getImageCss(bgImage) : ''}`
	}};
`

export const colorBackgroundCss = css<{ bgColor?: string }>`
	background: ${({ bgColor }) => color(convertColor(bgColor))};
`

const getImageCss = (bgImage: string) =>
	`url('${bgImage}') center / cover no-repeat`
